const BYTES_PER_KILOBYTE = 1024
const BYTES_PER_MEGABYTE = BYTES_PER_KILOBYTE * 1024

/** Use KB for sizes up to 1024 KB, then switch to MB. */
export function formatFileSize(bytes: number | null | undefined, emptyLabel = '文件') {
  const value = Number(bytes || 0)
  if (!value) return emptyLabel
  if (value > BYTES_PER_MEGABYTE) return `${(value / BYTES_PER_MEGABYTE).toFixed(1)} MB`
  return `${Math.max(1, Math.ceil(value / BYTES_PER_KILOBYTE))} KB`
}
